var _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecruitEntryIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "recruit_entry_icon1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.847,
    height: 55.676,
    viewBox: "0 0 70.847 55.676",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184174",
    "data-name": "\\uADF8\\uB8F9 184174",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131937",
    "data-name": "\\uD328\\uC2A4 131937",
    d: "M389.446,288.922a5.358,5.358,0,0,0-6.631-3.672l-50.8,14.581a5.36,5.36,0,0,0-3.673,6.63l8.475,29.527a5.36,5.36,0,0,0,6.631,3.672l50.8-14.582a5.36,5.36,0,0,0,3.673-6.631Z",
    transform: "translate(-327.71 -284.616)",
    fill: "#ffbf17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131938",
    "data-name": "\\uD328\\uC2A4 131938",
    d: "M389.678,288.63a5.79,5.79,0,0,0-7.155-3.964l-50.8,14.582a5.792,5.792,0,0,0-3.963,7.156l8.476,29.526a5.785,5.785,0,0,0,7.156,3.963l50.8-14.583a5.783,5.783,0,0,0,3.963-7.156Zm7.233,33.512a4.9,4.9,0,0,1-2.955,2.353l-50.8,14.583a4.943,4.943,0,0,1-6.106-3.383l-8.475-29.526a4.941,4.941,0,0,1,3.383-6.1l50.8-14.582a4.883,4.883,0,0,1,1.359-.192,4.944,4.944,0,0,1,4.746,3.574l8.476,29.526A4.9,4.9,0,0,1,396.912,322.142Z",
    transform: "translate(-327.535 -284.441)",
    fill: "#111"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184175",
    "data-name": "\\uADF8\\uB8F9 184175",
    transform: "translate(0.629 4.188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131939",
    "data-name": "\\uD328\\uC2A4 131939",
    d: "M389.938,290.361l-.816.233.454,1.584a6.705,6.705,0,0,1-1.409,6.3l-19.258,21.96a6.752,6.752,0,0,1-6.986,2.012l-28.082-8.378a6.7,6.7,0,0,1-4.545-4.594l-.053-.185-.818.233.054.187a7.545,7.545,0,0,0,5.12,5.172l28.082,8.38a7.6,7.6,0,0,0,7.868-2.267l19.258-21.958a7.545,7.545,0,0,0,1.587-7.09Z",
    transform: "translate(-328.424 -290.361)",
    fill: "#111"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184176",
    "data-name": "\\uADF8\\uB8F9 184176",
    transform: "translate(53.991 19.347)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154162",
    "data-name": "\\uC0AC\\uAC01\\uD615 154162",
    width: 0.849,
    height: 17.015,
    transform: "matrix(0.513, -0.859, 0.859, 0.513, 0, 0.729)",
    fill: "#111"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184177",
    "data-name": "\\uADF8\\uB8F9 184177",
    transform: "translate(7.163 30.687)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154163",
    "data-name": "\\uC0AC\\uAC01\\uD615 154163",
    width: 17.015,
    height: 0.849,
    transform: "translate(0 15.138) rotate(-62.831)",
    fill: "#111"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184178",
    "data-name": "\\uADF8\\uB8F9 184178",
    transform: "translate(12.226 43.553)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154164",
    "data-name": "\\uC0AC\\uAC01\\uD615 154164",
    width: 9.885,
    height: 6.047,
    transform: "translate(0 2.726) rotate(-16.01)",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184181",
    "data-name": "\\uADF8\\uB8F9 184181",
    transform: "translate(17.332 42.975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184179",
    "data-name": "\\uADF8\\uB8F9 184179"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131940",
    "data-name": "\\uD328\\uC2A4 131940",
    d: "M363.6,345.339a2.618,2.618,0,0,0-2.941.844,1.768,1.768,0,0,1-2.043.587,2.612,2.612,0,0,0-2.937.842,1.766,1.766,0,0,1-2.042.587,2.47,2.47,0,0,0-1.6-.054l.234.816a1.665,1.665,0,0,1,1.119.048,2.793,2.793,0,0,0,.881.161,2.628,2.628,0,0,0,.723-.108,2.494,2.494,0,0,0,1.332-.9,1.766,1.766,0,0,1,2.041-.585,2.613,2.613,0,0,0,2.938-.843,1.774,1.774,0,0,1,2.047-.588,2.485,2.485,0,0,0,1.605.053l-.233-.816A1.669,1.669,0,0,1,363.6,345.339Z",
    transform: "translate(-352.031 -345.178)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184180",
    "data-name": "\\uADF8\\uB8F9 184180",
    transform: "translate(0.597 2.08)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131941",
    "data-name": "\\uD328\\uC2A4 131941",
    d: "M364.44,348.28a2.616,2.616,0,0,0-2.94.845,1.771,1.771,0,0,1-2.044.587,2.61,2.61,0,0,0-2.936.843,1.766,1.766,0,0,1-2.041.586,2.49,2.49,0,0,0-1.6-.054l.234.816a1.674,1.674,0,0,1,1.119.048,2.762,2.762,0,0,0,.88.163,2.583,2.583,0,0,0,.723-.109,2.486,2.486,0,0,0,1.332-.9,1.769,1.769,0,0,1,2.041-.585,2.611,2.611,0,0,0,2.938-.844,1.77,1.77,0,0,1,2.047-.586,2.5,2.5,0,0,0,1.606.052l-.233-.815A1.667,1.667,0,0,1,364.44,348.28Z",
    transform: "translate(-352.875 -348.119)",
    fill: "#111"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitEntryIcon1);
export default __webpack_public_path__ + "static/media/recruit_entry_icon1.870a12511a7a30caddbe41657ea9cdb0.svg";
export { ForwardRef as ReactComponent };